import { getStoredSessionToken } from '../../../app/services/session.service';

async function request(path, method = 'GET') {
  const token = getStoredSessionToken();
  const response = await fetch(path, { method, headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(response.status === 403 ? 'Non hai accesso ai collegamenti di questo modulo.' : error?.message || 'Impossibile caricare i collegamenti tra affare e incassi. Riprova.');
  }
  return response.json();
}

export function listDealPayments(dealId, completed = false) {
  return request(`/api/accounting/payments?${completed ? 'completedDealId' : 'inProgressDealId'}=${encodeURIComponent(dealId)}`);
}

export function syncDealPayments(dealId, completed = false) {
  return request(`/api/accounting/deals/${completed ? 'completed' : 'in-progress'}/${encodeURIComponent(dealId)}/sync`, 'POST');
}

export async function settleDealPayments(dealId) {
  const result = await request(`/api/accounting/deals/completed/${encodeURIComponent(dealId)}/settle`, 'POST');
  window.dispatchEvent(new CustomEvent('webtika:deal-payments-updated', { detail: { completedDealId: dealId } }));
  return result;
}

export async function resolveAccountingDocumentLinks(entity, entityType) {
  const links = [];
  const add = (linkedModule, linkedEntityType, linkedEntityId) => {
    if (linkedEntityId != null && linkedEntityId !== '') links.push({ linkedModule, linkedEntityType, linkedEntityId });
  };
  const isDeal = ['IN_PROGRESS_DEAL', 'COMPLETED_DEAL', 'PROPOSAL'].includes(entityType);
  add(isDeal ? 'DEALS' : 'ACCOUNTING', entityType, entity.id);
  let completedId = entityType === 'COMPLETED_DEAL' ? entity.id : entity.completedDealId;
  let inProgressId = entityType === 'IN_PROGRESS_DEAL' ? entity.id : entity.inProgressDealId || entity.sourceInProgressDealId;
  let invoiceId = entityType === 'ACCOUNTING_INVOICE' ? entity.id : entity.invoiceId;
  if (invoiceId) {
    add('ACCOUNTING', 'ACCOUNTING_INVOICE', invoiceId);
    if (!completedId && !inProgressId) {
      const invoice = await request(`/api/accounting/invoices/${encodeURIComponent(invoiceId)}`);
      completedId = invoice.completedDealId;
    }
  }
  if (completedId && !inProgressId) {
    const deal = await request(`/api/deals/completed/${encodeURIComponent(completedId)}`);
    inProgressId = deal.sourceInProgressDealId;
  }
  if (inProgressId) {
    const deal = await request(`/api/deals/in-progress/${encodeURIComponent(inProgressId)}`);
    completedId = completedId || deal.completedDealId;
    add('DEALS', 'PROPOSAL', deal.sourceProposalId || entity.sourceProposalId);
  }
  add('DEALS', 'COMPLETED_DEAL', completedId);
  add('DEALS', 'IN_PROGRESS_DEAL', inProgressId);
  if (completedId || inProgressId) {
    const payments = await listDealPayments(completedId || inProgressId, Boolean(completedId));
    payments.forEach((payment) => {
      add('ACCOUNTING', 'ACCOUNTING_PAYMENT', payment.id);
      add('ACCOUNTING', 'ACCOUNTING_INVOICE', payment.invoiceId);
    });
  }
  return [...new Map(links.map((link) => [`${link.linkedModule}:${link.linkedEntityType}:${link.linkedEntityId}`, link])).values()];
}
